import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col } from 'reactstrap';

import Application from '../Application';
import Accordion from '../../components/Accordion';
import AccordionItem from '../../components/Accordion/components/AccordionItem';

import Concrete from './components/Concrete';
import ReinforcementAndConditions_ACI from './components/ReinforcementAndConditions/ReinforcementAndConditions_ACI';
import ReinforcementAndConditions_ANZ from './components/ReinforcementAndConditions/ReinforcementAndConditions_ANZ';
import { 
  ReinforcementAndConditions_EU, 
  ReinforcementAndConditions_AS } from './components/ReinforcementAndConditions/ReinforcementAndConditions_EU_AS';
import DrillingAndTemperature from './components/DrillingAndTemperature';

import { standardList } from '../../app.values';

import ServiceTemperature from './components/ServiceTemperature';
import Masonry from './components/Masonry';
import { APP_TEXTS } from '../../texts/texts';
import WoodMaterial from './components/WoodMaterial';

class Material extends Component {
  
  render() {
    return (
      <Row>
        <Col sm="12">
          {+this.props.designStandard !== +standardList['Masonry'] && (
            <Accordion className="application__accordion" appStatus={this.props.appStatus}>
              <AccordionItem id="concrete" title={APP_TEXTS.MATERIAL_CONCRETE_TITLE.Content}>
                <Concrete />
              </AccordionItem>

              {this.props.type === Application.types.WOOD_CONNECTION && 
               +this.props.designStandard !== +standardList['Masonry'] && (
                <AccordionItem id="wood-material" title={APP_TEXTS.MATERIAL_WOOD_TITLE.Content}>
                  <WoodMaterial />
                </AccordionItem>
              )}

              {this.renderChoice(this.props.type)}
            </Accordion>
          )}
          
          {+this.props.designStandard === +standardList['Masonry'] && (
            <Accordion className="application__accordion" appStatus={this.props.appStatus}>
              <AccordionItem id="masonry" title={APP_TEXTS.MATERIAL_MASONRY_TITLE.Content}>
                <Masonry />
              </AccordionItem>

              <AccordionItem id="service-temperature" title={APP_TEXTS.MATERIAL_SERVICE_TEMPERATURE_TITLE.Content}>
                <ServiceTemperature />
              </AccordionItem>
            </Accordion>
          )}
        </Col>
      </Row>
    );
  }

  componentMap = {
    [standardList['EU']]: ReinforcementAndConditions_EU,
    [standardList['ICC.Post']]: ReinforcementAndConditions_ACI,
    [standardList['ICC.Cast']]: ReinforcementAndConditions_ACI,
    [standardList['ANZ']]: ReinforcementAndConditions_ANZ,
    [standardList['CSA']]: ReinforcementAndConditions_ACI,
    [standardList['AS5216']]: ReinforcementAndConditions_AS,
    [standardList['AS3600']]: ReinforcementAndConditions_ANZ,
    [standardList['AnnexC']]: ReinforcementAndConditions_EU
  };

  renderChoice(type) {
    const Conditions = this.componentMap[this.props.designStandard];

    switch (type) {
      case Application.types.GENERAL_CALCULATION:
      case Application.types.BRACKET_ATTACHMENT:
      case Application.types.SAFETY_BARRIER:
      case Application.types.WOOD_CONNECTION:
        return (
          <AccordionItem id="reinforcement_and_conditions" 
          title={
            this.isANZStandart ? APP_TEXTS.MATERIAL_CONDITIONS_TITLE.Content : APP_TEXTS.MATERIAL_REINFORCEMENT_AND_CONDITIONS_TITLE.Content
          }>
            <Conditions />
          </AccordionItem>
        );

      case Application.types.REBAR_REINFORCEMENT:
        return (
          <AccordionItem id="drilling_and_temperature" 
          title={APP_TEXTS.MATERIAL_DRILLING_AND_TEMPERATURE_TITLE.Content}>
            <DrillingAndTemperature />
          </AccordionItem>
        );

      default:
        return null;
    }
  }

  get isANZStandart () {
    return (
      Number(this.props.designStandard) === standardList['ANZ'] ||
      Number(this.props.designStandard) === standardList['AS5216'] ||
      Number(this.props.designStandard) === standardList['AS3600'] 
    );
  }

}

const mapState = state => ({
  type: state.main.appType,
  designStandard: state.main.localization.designStandard,
  appStatus: state.main.status
});

export default connect(mapState)(Material);



// WEBPACK FOOTER //
// ./src/views/Material/index.js